<template>
  <div>

    <FilterExamenes />

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">

        <div
          v-if="showButtonReportes" 
          class="d-flex justify-content-end align-items-center"
        >
          <h5
            class="mr-2">Reporte:
          </h5>
          <b-button 
            :title="showTableLabAux ? 'Descargar Laboratorios Auxiliares' : 'Descargar Laboratorios As400'"
            class="my-1" variant="outline-secondary" size="md" 
            @click="descargarExcel" 
            :disabled="descargandoBase"
          >
            <div v-if="descargandoBase">
              <b-spinner small type="grow"/>
              <label>Descargando..</label>
            </div>
            <i class="fas fa-file-excel" />
          </b-button>
        </div>

        <div v-if="!showTableLabAux" class="d-flex justify-content-between mb-1 align-items-end">
          <b-button variant="primary" @click="linkOrders">
            <i class="fas fa-id-card" style="margin-right: 10px;" title="Identificación" />
            <span>Vincular Ordenes</span>
          </b-button>


          <h5>Resultados: {{ table.totalRows }}</h5>
        </div>
        <b-row v-if="!showTableLabAux">
          <b-col cols="12">

            <!-- tabla de examenes as 400 -->
            <b-table 
              v-if="showTableLab400" 
              bordered striped responsive 
              :per-page="table.perPage" 
              :items="itemslabas4"
              :fields="tableFieldsLab400" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
              <template #cell(acciones)="data">

                <div class="d-flex justify-content-end">
                  <b-button 
                    v-if="showActaLaboratorio" 
                    title="Acta Laboratorio" 
                    size="sm" 
                    @click="downloadActaLaboratorio(data.item)"
                  >
                    <i class="fa-solid fa-i"/>
                  </b-button>

                  <b-button 
                    v-if="data.item.urlSolLabDer || data.item.idDoctor === '90'"
                    title="Solicitud de Laboratorio 10 A" size="sm"
                    @click="descargarSolicitudLaboratorioDerivado(data.item.urlSolLabDer)">
                    <i class="fa-solid fa-a"></i>
                  </b-button>

                  <b-button 
                    v-if="showButton10A && !data.item.urlSolLabDer && data.item.idDoctor !== '90'"
                    title="Solicitud de Laboratorio 10 A" size="sm"
                    @click="descargarSolicitudLaboratorio(data.item.id)">
                    <i class="fa-solid fa-a"/>
                  </b-button>

                  <b-button 
                    v-if="data.item.idDoctor === '90'" title="Editar Laboratorio Derivado" variant="warning"
                    size="sm" @click="editarLabDerivado(data.item.dataEditLabDer)">
                    <i class="fa-solid fa-pen-to-square"/>
                  </b-button>

                  <!-- <b-button 
                    v-if="data.item.estadoOrden == 2 && !data.item.urlMspCalificacion1" 
                    variant="primary"
                    size="sm" 
                    @click="onLoadMSP(data.item)"
                  >
                    <i class="fas fa-arrow-up" style="color: white" />
                  </b-button> -->

                  <b-button 
                    v-if="showButtonLoadMSP" variant="primary" size="sm" @click="onLoadMSP(data.item)">
                    <i class="fas fa-arrow-up" style="color: white" />
                  </b-button>

                  <b-button 
                    v-if="showButtonAgendamiento && data.item.estadoOrden < 2" variant="primary" size="sm"
                    title="Programar Fecha" @click="programarItem(data.item.idestlab, data.item.token)">
                    <i class="fas fa-calendar" style="color: white" />
                  </b-button>


                  <b-button 
                    v-if="showButtonAgendamiento && data.item.estadoOrden > 1" variant="warning" size="sm"
                    title="Reprogramar Fecha" @click="programarItem(data.item.idestlab, data.item.token)">
                    <i class="fas fa-calendar" style="color: white;" />
                  </b-button>


                  <b-button variant="info" size="sm" @click="onViewLab400(data.item.token)">
                    <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                  </b-button>


                  <b-button v-if="data.item.estadoOrden == 4" size="sm" @click="downloadReportId(data.item.urlinforme)">
                    <i class="fas fa-id-card" style="margin-right: 10px;" title="Informe" />
                  </b-button>

                  <b-button 
                    v-if="canViewForm13(data.item.idsLaboratorios, data.item.estadoOrden)" 
                    size="sm" 
                    @click="navigateToQuery('13a', data.item.token)"
                    variant="primary"
                    title="Formulario 13"
                  >
                    13
                  </b-button>
                </div>
              </template>
              <template #cell(numeroOrdenprise)="data">
                <span v-if="data.item.estadoOrden == 2 && data.item.auxiliarMuestras">
                  <input 
                    type="text" 
                    v-model="data.item.numeroOrdenprise" 
                    class="form-control"
                    style="height: 30px; width: 120px;"
                  />
                </span>
                <div v-if="data.item.estadoOrden > 2" class="d-flex align-items-center">
                  {{ data.item.numeroOrdenprise }}
                  <b-button 
                    v-if="showButtonOrdenOrion && data.item.estadoOrden > 2" pill
                    class="ml-1 d-flex justify-content-center align-items-center" style="height: 30px; width: 30px;"
                    variant="info" size="sm" @click="onEditOrdenOrion(data.item)">
                    <i class="fas fa-pen" style="color: white" />
                  </b-button>
                </div>
              </template>
              <template #cell(estadoOrden)="data">
                <span v-if="data.item.estadoOrden == 1">Creado</span>
                <span v-if="data.item.estadoOrden == 2">Programado</span>
                <span v-if="data.item.estadoOrden == 3">Vinculado</span>
                <span v-if="data.item.estadoOrden == 4">Validado</span>

                <span class="d-block" :class="data.item.urlMspCalificacion1 ? 'text-success' : 'text-danger'">
                  {{ data.item.urlMspCalificacion1 ? 'MSP Cargado' : 'MSP Pendiente' }}
                </span>
              </template>
            </b-table>


            <b-skeleton-wrapper v-if="loadingTable">
              <b-skeleton v-for="i in 15" :key="i" width="100%" height="50px" />
            </b-skeleton-wrapper>

            <div v-if="itemslabas4.length == 0 && !loadingTable">
              <p>No se encontraron registros</p>
            </div>

            <b-pagination 
              v-if="itemslabas4.length > 0" 
              v-model="table.currentPage" 
              :total-rows="table.totalRows"
              :per-page="table.perPage"
              first-number :small="true" 
              class="mb-0 mx-auto" 
              align="center" 
              prev-class="prev-item"
              next-class="next-item" @change="onChangePage">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
        <TableLabAux 
          v-if="showTableLabAux" 
          :filters="filters" 
          :descargarExcelAux="descargarExcelAux"  
          @descarga-completada="descargandoBase = false" 
        />

      </b-card>


      <b-modal id="modal-programar-fecha" hide-footer>
        <h3 class="modal-title">Programar Fecha</h3>
        <div class="my-3">
          <input 
            id="fecha-programada" type="datetime-local" v-model="fechaProgramadaSeleccionada"
            class="form-control" />
        </div>

        <div class="d-flex justify-content-end mb-2">
          <b-button class="mr-1" variant="secondary" @click="cancelFechaProgramada"> Cancelar
          </b-button>

          <b-button 
            :disabled="!fechaProgramadaSeleccionada" 
            variant="primary" 
            @click="actualizarFechaProgramada"
          >
            Actualizar
          </b-button>
        </div>

      </b-modal>

      <ModalViewLab400 :idExa="idVerExamen" :idMod="idMod" />

    </b-overlay>

    <b-modal id="modal-editar-laboratorioderivado" title="Editar Datos Laboratorio Derivado" size="xl" hide-footer>
      <!-- Contenido del modal -->
      <EditarLaboratorioDerivado :dataLabDerivado="dataLabDerivado" />
    </b-modal>

    <ModalViewFile 
      v-show="fileToView" 
      :urlFile="fileToView" 
      v-model="isModalFileVisible" 
    />

    <ModalEditOrdenOrion :isVisible.sync="showModalOrdenOrion" :item.sync="itemToEditOrion" />

    <ModalLoadMSP :tipolab="'1'" :isVisible.sync="showModalLoadMSP" :dataLaboratorio="dataToUpdateFileMsp" />

    <Formulario013a
      v-if="showTableLab400"
      isLabAs400
    />

  </div>
</template>

<script>
import { BootstrapVue } from 'bootstrap-vue';
import { mapState } from 'vuex';
import rutas from '@/assets/utils/rutas.json';
import axios from 'axios';
import { comprobarPermisos, comprobarRoles, getEstablecimientoLS, getIdDoctorLS } from "@/shared/helpers";
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import 'flatpickr/dist/flatpickr.css';
import actions from '@/assets/utils/utils';
import { ModalViewFile } from '@/shared/components';
import { ROLES } from '@/shared/constants';
import Formulario013a         from "@/views/procesoclinico/components/Formularios/Formulario013a.vue";
import ModalViewLab400 from "../components/ModalViewLab400.vue";
import { ModalEditOrdenOrion, ModalLoadMSP, FilterExamenes, TableLabAux } from '../components';
import EditarLaboratorioDerivado from '../components/EditarLaboratorioDerivado/EditarLaboratorioDerivado.vue';
import { labAs400Service } from '../services';


export default {
  components: {
    ...BootstrapVue.components,
    ModalViewLab400,
    ModalEditOrdenOrion,
    ModalViewFile,
    ModalLoadMSP,
    EditarLaboratorioDerivado,
    FilterExamenes,
    TableLabAux,
    Formulario013a
  },

  data() {
    return {
      descargarExcelAux: false,
      descargandoBase: false,
      loadingTable: false,
      isModalFileVisible: false,
      fileToView: null,
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),


      filters: {
        search: null,
        especialidad: null,
        estadoLaboratorio: null,
        modalidad: null,
        fechaDesde: null,
        fechaHasta: null,
        doctor: null,
        observaciones: null,
        establecimiento: null,
      },

      table: {
        currentPage: 1,
        totalRows: 0,
        perPage: 15,
        sortBy: null,
        sortDesc: false
      },

      flatpickrConfig: {
        allowInput: true, // Muestra un campo de entrada de texto adicional
        minDate: '1900-01-01',
        maxDate: new Date(),
        enableTime: true,
      },
      itemToEditOrion: null,

      showModalLoadMSP: false,
      showModalOrdenOrion: false,
      dataToUpdateFileMsp: null,
      mostrarLoader: false,
      establecimiento: null,
      idMod: null,
      excel_btn: null,
      idVerExamen: null,
      pdf_btn: null,
      especialidad: null,
      pageOptions: [3, 5, 10],
      sortBy: '',
      sortDesc: false,
      infoOrion: null,

      listaAcciones: [],

      fieldsLab400: [
        { key: 'establecimiento', label: 'Establecimiento', sortable: true, thClass: 'text-center' },
        { key: 'fechaIngreso', label: 'Fecha Atencion', sortable: true, thClass: 'text-center' },
        { key: 'fechaProgramada', label: 'Fecha Programada', sortable: true, thClass: 'text-center' },
        { key: 'paciente', label: 'Paciente', sortable: true, thClass: 'text-center' },
        { key: 'doctor', label: 'Doctor', sortable: true, thClass: 'text-center' },
        { key: 'numeroOrden', label: 'Orden AS400', sortable: true, thClass: 'text-center' },
        { key: 'numeroOrdenprise', label: 'Orden orion', sortable: true, thClass: 'text-center' },
        { key: 'especialidad', label: 'Especialidad', sortable: true, thClass: 'text-center' },
        { key: 'estadoOrden', label: 'Estado', sortable: true, thClass: 'text-center' },
        { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' }
      ],


      itemslabas4: [],

      codLabos: [
        '0000000010', '0000000023',
      ],
      idEstlab: null,
      fechaProgramadaSeleccionada: null,
      tokenLab400ToChangeDate: null,
      dataLabDerivado: null,
    }
  },

  async created() {

    comprobarPermisos(this.$route);
    await this.loadDataInit();
    this.getDataTable();
    this.setToken();

  },

  mounted() {
    actions.setearTitulo('Estudio Laboratorio');
  },


  methods: {

    async loadDataInit() {

      // buscar los ids en la cartera que tenga el codigo 390001 que es el examen que necesita el form13
      const CODIGOS_FORM13 = ['390001'];
      const establecimiento = getEstablecimientoLS();

      const resultsLabForm13 = await Promise.all(
        CODIGOS_FORM13.map(
          codigo => labAs400Service.searchLab(codigo, establecimiento.id)
        )
      );

      this.idsForm13 = resultsLabForm13.flatMap(result => result[0].id);
    },


    async descargarExcel() {
      this.descargandoBase = true;
      if (this.showTableLabAux) {
        this.descargarExcelAux = true;
        
        // Resetear después de un breve tiempo para permitir futuras descargas
        setTimeout(() => {
          this.descargarExcelAux = false;
        }, 1000);
        
      } else {
        await this.getDataTable('1');
      }
      this.descargandoBase = false;
    },


    async getDataTable(excel) {

      this.loadingTable = true;

      const establecimientoUser = getEstablecimientoLS();
      // const establecimiento = this.isAdmin ? '0' : establecimientoUser.id;
      const establecimiento = this.filters.establecimiento || establecimientoUser.id;


      const idDoctor = getIdDoctorLS();
      const viewAll = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.AUX_LABORATORIO, ROLES.LABORATORIO, ROLES.AGENDAMIENTO]);

      const params = {
        modalidad: this.filters.modalidad || '1',
        search: this.filters.search || '',
        estadoLaboratorio: this.filters.estadoLaboratorio,
        cobertura: this.filters.cobertura || '',
        especialidad: this.filters.especialidad || '',
        doctor: viewAll ? '' : idDoctor,
        establecimiento,
        fechaDesde: this.filters.fechaDesde || '',
        fechaHasta: this.filters.fechaHasta || '',
        page: this.table.currentPage,
        pageSize: this.table.perPage,
        excel: excel,
        tipoFecha: this.filters.tipoFecha || '',
        observaciones: this.filters.observaciones || ''
      }
      try {
        if (this.filters.modalidad === '1') {
          await this.getLabs400(params)
          return;
        }
      } catch (error) {
        this.descargandoBase = false
        console.log("error")
      }

    },



    async getLabs400(params) {

      const responseLab = await labAs400Service.getAll(params);

      if (!responseLab || !responseLab.data) return;

      if (responseLab.dataarchivo) {
        const data = responseLab.dataarchivo
        actions.cargarArchivos(data, "laboratorios.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
        this.descargandoBase = false
      }

      this.itemslabas4 = await this.mapperAs400(responseLab.data);
      console.log("this.itemslabas4", this.itemslabas4)
      this.table.totalRows = responseLab.total;
      this.loadingTable = false;
    },


    async mapperAs400(dataLab) {

      if (!dataLab) return [];

      const mappedData = dataLab.filter(item => item.estudiolab.consultamedica).map(item => {

        const dataCita = item.estudiolab.consultamedica.cita;
        const dataPaciente = dataCita.paciente;
        const dataDoctor = dataCita.doctor;

        const idsLaboratorios = item.idslaboratorios.split(',');

        const auxiliarMuestras = item.auxiliarMuestras
          ? {
            value: item.auxiliarMuestras.id,
            text: `${item.auxiliarMuestras?.idPersona.primerApellido} ${item.auxiliarMuestras?.idPersona.primerNombre}`
          }
          : null;

        return {
          id: item.id,
          token: item.token,

          establecimiento: dataCita.establecimiento.Descripcion,
          idDoctor: dataDoctor.id,
          doctor: `${dataDoctor.idPersona.primerApellido} ${dataDoctor.idPersona.primerNombre}`,
          especialidad: dataDoctor.especialidad.descripcion,

          pacienteId    : dataPaciente.id,
          identificacion: dataPaciente.persona.identificacion,
          paciente      : `${dataPaciente.persona.identificacion} - ${dataPaciente.persona.primerApellido} ${dataPaciente.persona.primerNombre}`,

          modalidad: '1',

          idsLaboratorios,
          fechaIngreso   : `${dataCita.fechaCita} ${dataCita.horaCita}`,
          fechaProgramada: item.fechaProgramada ? new Date(item.fechaProgramada).toLocaleString("pt-BR") : '',
          urlSolLabDer   : item.estudiolab?.consultamedica?.cita?.urlSolLabDer,
          idestlab       : item.estudiolab.id,

          numeroOrden        : item.numeroOrden,
          numeroOrdenprise   : item.nordenEnterprise,
          estadoOrden        : item.estadoLab400,
          urlinforme         : item.urlInformeEnterprise,
          urlMspCalificacion1: item.urlMspCalificacion,
          urlMspCalificacion2: item.urlMspCalificacion1,
          urlMspCalificacion3: item.urlMspCalificacion2,
          auxiliarMuestras   : auxiliarMuestras,

          dataEditLabDer: {
            id: item.id,
            moda: item.estudiolab.modalidad,
            idEstLab: item.estudiolab.id,
            labo: item,
            cita: item.estudiolab.consultamedica.cita
          }
        };
      });

      return mappedData;
    },


    async downloadActaLaboratorio(item) {
      const idCita = item?.dataEditLabDer?.cita?.id;

      if (!idCita) {
        this.$swal({
          title: "Acta no disponible",
          text: "No se pudo identificar la cita asociada al laboratorio.",
          icon: "warning",
          confirmButtonColor: "#089599",
        });
        return;
      }

      const query = `                
       query qrGetDocumentActa($idCita: String!, $servicio : String) {
          getDocumentActa(idCita: $idCita, servicio: $servicio) {
            status
            message
            citaPdf
            cita{
              id
              fechaCita
              horaCita
              paciente{
                persona{
                  primerNombre
                  primerApellido
                  identificacion
                }
              }
            }
          }
        }
      `;

      const variables = {
        idCita, servicio: 'LABORATORIO'
      }

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.status === 200) {
          const pdfBase64 = response.data.data.getDocumentActa.citaPdf;
          actions.cargarArchivos(pdfBase64, "acta_" + idCita + ".pdf", "data:application/pdf;base64");
        }
      } catch (error) {
        console.error("Error al cargar la cobertura:", error);
        this.$swal({
          title: "Error",
          text: "No se pudo descargar el acta del laboratorio.",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },


    async descargarSolicitudLaboratorio(idLaboratorio) {
      const query = `
        query MyQuery {
          generateForm010a(idLab: ${idLaboratorio}) {
            message
            pdfBase64
            status
            nombres
            identificacion
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", { query });

        if (response.data.data.generateForm010a.pdfBase64) {

          const item = response.data.data.generateForm010a.pdfBase64;
          const nombres = response.data.data.generateForm010a.nombres;
          const identificacion = response.data.data.generateForm010a.identificacion;

          actions.cargarArchivos(
            item,
            "solicitudLaboratorio_" + `${identificacion}-${nombres}-${idLaboratorio}` + ".pdf",
            "data:application/pdf;base64"
          );
        } else {
          console.error("Error al descargar el archivo:", error);
          this.$swal({
            title: "Error",
            text: "El archivo no existe, comunicar con el adminsitrador sistema",
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: "Error al descargar el archivo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },

    async descargarSolicitudLaboratorioDerivado(url) {
      if (url) {
        const fileName = decodeURIComponent(url);
        const fullDownloadUrl = `${rutas.axios}file/show${fileName}`;

        try {
          const response = await fetch(fullDownloadUrl);
          if (!response.ok) {
            throw new Error("No se pudo descargar el archivo");
          }

          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = blobUrl;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(link);
        } catch (error) {
          this.$swal({
            title: "Error",
            text: "Un error ocurrió mientras se descargaba el archivo",
            icon: "error",
            confirmButtonText: "Entendido",
          });
        }
      } else {
        this.$swal({
          title: "No se ha subido",
          text: "La solicitud de laboratorio por derivacion no ha sido subida, por favor subir",
          icon: "error",
          confirmButtonText: "Entendido",
        });
      }
    },


    async editarLabDerivado(dataEditLabDer) {
      const { labo, moda, idEstLab, cita } = dataEditLabDer;
      const laboratorioList = await this.cargarDataLaboratorios(labo, moda, idEstLab)

      await this.$store.commit("setLaboratorioList", laboratorioList);

      let data = cita

      this.dataLabDerivado = {
        cobSeleccionada: data.cobSeleccionada,
        paciente: `${data.paciente.persona.primerNombre} ${data.paciente.persona.primerApellido}`,
        idPaciente: data.paciente.id,
        identificacionPaciente: data.paciente.persona.identificacion,
        fecderivacion: data.fecderivacion,
        codderivacion: data.codderivacion,
        urlSolLabDer: data.urlSolLabDer,
        idCita: data.id,
        idLabEnviado: data.idLabEnviado,
        itemCit: {
          urlmsppac: data.urlsMspPaciente,
          urlmsptit1: data.urlsMspTitular1,
          urlmsptit2: data.urlsMspTitular2,
          urlmsptit3: data.urlsMspTitular3,
          urlDerivacion: data.urlDerivacion,
          urlCodDerivacion: data.urlCodigoDer,
          urlSolicitudLaboratorio: data.urlSolLabDer,
        },
      };

      this.$bvModal.show("modal-editar-laboratorioderivado");
    },

    async buscarLaboratoriosIds(ids) {
      const query = `
        query MyQuery($ids : [ID]) {
          getLaboratorios(ids:$ids) {
            codigo
            descripcion
            id
          }
        }
      `;
      const variables = {
        ids
      }

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.data.data.getLaboratorios) {
          const detalle = response.data.data.getLaboratorios
          let exams = []

          for (let i = 0; i < detalle.length; i++) {
            exams.push(`(${detalle[i].codigo}) ${detalle[i].descripcion} `)
          }

          exams = exams.join(', ')

          const labis = { detalle, exams }
          return labis
        }
      } catch (error) {
        console.error("ocurrio un error", error)
      }
    },

    async cargarDataLaboratorios(labo, moda, idEstLab) {
      let labis = null
      let detalle = []
      let exams = []
      let laboratorios = []
      if (labo) {

        const idslaboratorios = labo.idslaboratorios.split(', ')
        if (idslaboratorios) {
          for (let i = 0; i < idslaboratorios.length; i++) {

            labis = await this.buscarLaboratoriosIds([idslaboratorios[i]])
            detalle.push(labis.detalle[0])
            exams.push(labis.exams)

          }
          labis.detalle = detalle
          labis.exams = exams.join(", ")
          labis.id = labo.id
          labis.norden = labo.numeroOrden
          labis.justificacion = labo.justificacion
          labis.estado = labo.estadoLab400
          laboratorios.push(labis)
        }

        const responseLab = [
          {
            id: 0,
            labaux: [],
            laboratorios: laboratorios,
            moda: moda.id,
            idEstLab: idEstLab
          }
        ]

        return responseLab
      }
    },

    onLoadMSP(dataItem) {
      this.showModalLoadMSP = true;
      this.dataToUpdateFileMsp = dataItem;
    },

    onEditOrdenOrion(item) {
      this.showModalOrdenOrion = true;
      this.itemToEditOrion = item;
    },

    onChangePage(page) {
      this.table.currentPage = page;
      this.getDataTable();
    },

    async actualizarEstadoOrdenAs4000() {
      const query = `
        mutation MyMutation($id : ID!, $estadoOrden: String!) {
          actualizarEstOrdenAs400(id: $id, estadoOrden: $estadoOrden) {
            message
            status
          }
        }
      `;
      const variables = {
        id: this.tokenLab400ToChangeDate,
        estadoOrden: '2',
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });

      } catch (error) {
        console.error("You have an error in update", error)
      }
    },


    programarItem(idLab, tokenLab400) {
      this.idEstlab = idLab
      this.tokenLab400ToChangeDate = tokenLab400
      this.$bvModal.show("modal-programar-fecha");
    },


    async actualizarFechaProgramada() {
      
      const confirmation = await this.$swal({
        title: "¿Estás seguro de actualizar la fecha?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Programar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmation.isConfirmed) return;

      const fechaProgramada = this.fechaProgramadaSeleccionada;

      const responseUpdate = await labAs400Service.updateByToken(this.tokenLab400ToChangeDate, { fechaProgramada: fechaProgramada })

      if (!responseUpdate) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
        });

        return;
      }
      await this.$swal({
        icon: "success",
        title: "Éxito",
        text: "La fecha se actualizó correctamente.",
      });

      // await this.actualizarEstadoOrdenAs4000()
      this.$router.go(0);
    },


    cancelFechaProgramada() {
      this.$bvModal.hide("modal-programar-fecha");
      this.fechaProgramadaSeleccionada = "";
    },


    onViewLab400(tokenLab400) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            view_laboratorio: tokenLab400
          }
        });
      } catch (error) { console.log("este es el rror", error) }
    },


    buscarEstlab() {
      this.getDataTable();
    },

    downloadReportId(downloadUrl) {
      this.fileToView = downloadUrl;
      this.isModalFileVisible = true;
    },


    linkOrders() {
      const items = this.filters.modalidad === '1'
        ? this.itemslabas4
        : this.itemslabaux;

      const orderData = items.map(item => ({
        id: item.id,
        token: item.token,
        numeroOrdenprise: item.numeroOrdenprise,
        estadoOrion: item.estadoOrden
      }));

      this.saveNoOrderOrion(orderData);
    },


    async saveNoOrderOrion(orderData) {
      const ordLinked = [];

      const promises = orderData.map(async (item) => {

        if (!item.numeroOrdenprise || item.estadoOrion !== '2') return;
        const response = await labAs400Service.updateByToken(item.token, { codigoOrion: item.numeroOrdenprise })
        if(response.laboratorioAs400 == null){
          await this.$swal({
            title: 'Error al guardar Codigo Orion',
            text: `${response.message}`,
            icon: 'error',
            confirmButtonText: 'Entendido'
          });  
        }

        if (response) ordLinked.push(item.id);
      });

      await Promise.all(promises);

      if (ordLinked.length > 0) {
        await this.$swal({
          title: 'Ordenes actualizadas',
          text: `Ordenes actualizadas (ids):  ${ordLinked.join(', ')}`,
          icon: 'success',
          confirmButtonText: 'Entendido'
        });

        this.$router.go(0);
      }
    },


    editItem(idAdm) {
      this.$router.push({
        name: 'editar_admision',
        params: { id: idAdm }
      });
    },


    onRowSelected(items) {
      this.selected = items
    },

    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },


    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem('permisos');
      return permisosUsuario.indexOf(permission) !== -1;
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },

    syncFilters() {
      const newValue = this.stFilterLaboratorios;

      this.filters = {
        search: newValue?.search || null,
        modalidad: newValue?.modalidad || null,
        estadoLaboratorio: newValue?.estadoLaboratorio || null,
        cobertura: newValue?.cobertura || null,
        especialidad: newValue?.especialidad || null,
        tipoFecha: newValue?.tipoFecha || null,
        fechaDesde: newValue?.fechaDesde || null,
        fechaHasta: newValue?.fechaHasta || null,
        observaciones: newValue?.observaciones || null,
        establecimiento: newValue?.establecimiento || null
      }

      this.table.currentPage = 1;
    },


    canViewForm13(idsLaboratorios, estadoLaboratorio){

      const existeCitologia = this.idsForm13.some(id => idsLaboratorios.includes(id));
      const estadoValido = parseInt(estadoLaboratorio) > 1;

      return estadoValido && existeCitologia;
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
  },
  computed: {
    ...mapState({
      stFilterLaboratorios: state => state.generals.filterLaboratorios,
    }),
    isXima() {
      return this.currentEstablecimiento?.uniCodigo === '36451';
    },
    tableFieldsLab400() {
      if (this.isXima) return this.fieldsLab400;
      return this.fieldsLab400.filter(field => field.key !== 'establecimiento');
    },
    showButtonReportes(){
      const hasPermission = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.ESTADISTICAS, ROLES.JEFE_VALIDACIONES, ROLES.JEFE_AUDITOR, ROLES.AUDITOR, ROLES.DIGITADOR]);
      return hasPermission;
    },
    showTableLab400() {
      return this.itemslabas4 && !this.loadingTable && this.filters.modalidad === "1";
    },

    showTableLabAux() {
      return this.filters.modalidad === "2";
    },
    
    isAdmin() {
      return comprobarRoles([ROLES.ADMINISTRADOR]);
    },
    showButtonDeleteLaboratorio() {
      return comprobarRoles([ROLES.JEFE_MEDICO]);
    },
    showButtonAgendamiento() {
      return comprobarRoles([
        ROLES.JEFE_MEDICO,
        ROLES.AGENDAMIENTO,
        ROLES.AUX_LABORATORIO,
        ROLES.LABORATORIO
      ]);
    },

    showButtonLoadMSP() {
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.AGENDAMIENTO, ROLES.AUX_LABORATORIO, ROLES.LABORATORIO]);
    },

    showButtonOrdenOrion() {
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.AUX_LABORATORIO, ROLES.LABORATORIO]);
    },

    showButton10A() {
      return comprobarRoles([
        ROLES.JEFE_MEDICO,
        ROLES.AUX_LABORATORIO,
        ROLES.LABORATORIO,
        ROLES.AGENDAMIENTO,
        ROLES.JEFE_VALIDACIONES,
        ROLES.DIGITADOR
      ]);
    },
    showActaLaboratorio() {
      return comprobarRoles([
        ROLES.ADMISION,
        ROLES.JEFE_MEDICO,
        ROLES.ADMINISTRADOR,
        ROLES.AGENDAMIENTO,
        ROLES.AUX_LABORATORIO,
        ROLES.LABORATORIO,
      ]);
    },

  },

  watch: {

    stFilterLaboratorios: {
      deep: true,
      handler() {
        this.syncFilters();
        this.getDataTable();
      }
    },

  }
}
</script>
